/* Editorial underlined form fields. Pass `dark` for the TestGuard theme. */

export function Label({ children, htmlFor, required, dark }) {
  return (
    <label
      htmlFor={htmlFor}
      className={`mb-2 block text-[11px] font-600 uppercase tracking-widest ${dark ? "text-white/55" : "text-ink/50"}`}
    >
      {children} {required && <span className="text-leaf">*</span>}
    </label>
  );
}

export function Input({ id, dataTestId, dark, ...props }) {
  return (
    <input
      id={id}
      data-testid={dataTestId}
      className={`w-full border-b bg-transparent pb-2.5 outline-none transition-colors duration-300 focus:border-leaf ${
        dark ? "border-white/25 text-white placeholder:text-white/35 [color-scheme:dark]" : "border-ink/20 text-ink placeholder:text-ink/30"
      }`}
      {...props}
    />
  );
}

export function Textarea({ id, dataTestId, dark, ...props }) {
  return (
    <textarea
      id={id}
      data-testid={dataTestId}
      rows={3}
      className={`w-full resize-none border-b bg-transparent pb-2.5 outline-none transition-colors duration-300 focus:border-leaf ${
        dark ? "border-white/25 text-white placeholder:text-white/35" : "border-ink/20 text-ink placeholder:text-ink/30"
      }`}
      {...props}
    />
  );
}

export function Select({ id, dataTestId, dark, children, ...props }) {
  return (
    <select
      id={id}
      data-testid={dataTestId}
      className={`w-full border-b bg-transparent pb-2.5 outline-none transition-colors duration-300 focus:border-leaf ${
        dark ? "border-white/25 text-white [color-scheme:dark]" : "border-ink/20 text-ink"
      }`}
      {...props}
    >
      {children}
    </select>
  );
}
